"use client";

import { useEffect } from "react";
import { setupFetchInterceptor } from "../lib/fetch-interceptor";

/**
 * Client component that sets up the fetch interceptor on mount
 * This ensures all fetch requests (including ChatKit SDK) include the auth token
 *
 * Note: The unauthorized handler should be registered separately (e.g., in AuthGuard)
 * using setUnauthorizedHandler from fetch-interceptor
 */
export function FetchInterceptor() {
  useEffect(() => {
    // Setup the fetch interceptor when component mounts
    setupFetchInterceptor();

    // Cleanup is handled by the interceptor itself (it replaces global fetch)
    // No need to restore on unmount as we want it active for the entire app lifecycle
  }, []);

  // This component doesn't render anything
  return null;
}

